import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';
import { upperCase } from 'lodash';

import { SortDirection } from 'core/enums';

import { Actions } from './elements';

interface IColumnDefParams {
  canManageParts: boolean;
}

export const columnDef = ({ canManageParts }: IColumnDefParams): ColDef[] => {
  const baseColumns: ColDef[] = [
    {
      headerName: t('headerBaseUom'),
      field: 'fromUom',
      filter: 'agTextColumnFilter',
      sort: SortDirection.ASC,
      flex: 1,
      valueFormatter: (params) => params?.value && upperCase(params.value),
    },
    {
      headerName: t('headerAlternateUom'),
      field: 'toUom',
      filter: 'agTextColumnFilter',
      flex: 1,
      valueFormatter: (params) => params?.value && upperCase(params.value),
    },
    {
      headerName: t('headerMultiplier'),
      field: 'multiplier',
      filter: 'agTextColumnFilter',
      flex: 1,
    },
  ];

  if (!canManageParts) {
    return baseColumns;
  }

  return [
    {
      colId: 'actions',
      headerName: '',
      width: 80,
      maxWidth: 80,
      pinned: 'left',
      sortable: false,
      resizable: false,
      lockPinned: true,
      suppressHeaderMenuButton: true,
      suppressColumnsToolPanel: true,
      cellRenderer: Actions,
    },
    ...baseColumns,
  ];
};
